// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"971f39d74fcd366982a2","303":"57857d46f53d8052e061","495":"019d9556e545d8d77cee"}[chunkId] + ".js";
};